import { Dialog, DialogContent, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material'
import { t } from 'i18next'
import React, { useEffect, useState } from 'react'
import { IoMdInformationCircleOutline } from 'react-icons/io'
// import MonthPicker from 'src/Common/ui/MonthYearPicker'
import SelectInput from 'src/Common/ui/selectInput'
import { freqCal, generateMonthArray } from 'src/lib/utils'

export default function CustomTimelineDialog({ type = 'Edit', frequency, customMonthData, setCustomMonthData, data, cycle, timeline, isOpen, handleClose, interCutOff }) {
    const [monthData, setMonthData] = useState([])
    useEffect(() => {
        setMonthData(data)
    }, [data])
    useEffect(() => {
        let temp = null
        let nextyear = false
        const gap = freqCal(frequency)
        setCustomMonthData(monthData?.map((item, i) => {
            const dueDate = new Date()
            dueDate.setMonth(item.dueByMonth - 1)
            const beforeMonth = new Date()
            beforeMonth.setMonth((item.dueByMonth - 1))
            beforeMonth.setMonth(beforeMonth.getMonth() - gap)
            dueDate.setDate(timeline)
            const dueFor = new Date()
            dueFor.setMonth(item.dueForMonth - 1)
            if (temp > item.dueForMonth || frequency === 4) {
                nextyear = true
            }
            if (nextyear) {
                dueFor.setFullYear(dueFor.getFullYear() + 1)
            }
            temp = item.dueForMonth
            if (i === monthData.length - 1) {
                setEndYear(dueFor.getFullYear())
            }
            return {
                // -${dueFor.getFullYear()}
                dueFor: (gap === 1 ? '' : ` ${beforeMonth.toLocaleString('en-US', { month: 'short' })} - `) + `${dueFor.toLocaleString('en-US', { month: 'short' })}`,
                dueDate,
                dueByMonth: item.dueByMonth,
                dueForMonth: item.dueForMonth
            }
        }))
    }, [monthData])
    const [endYear, setEndYear] = useState(0)
    const onChange = (value, index) => {
        const newData = customMonthData.map((item, i) => {
            if (i === index) {
                return { ...item, dueByMonth: value }
            }
            return item
        })
        setCustomMonthData(newData)
        console.log(value, index)
    }
    let tempValue = 11
    const convertDate = (dueBy, dueFor, timeline) => {
        const date = new Date()
        date.setMonth(dueBy - 1)
        if (dueFor === 12) {
            tempValue = tempValue + 1
        }
        if (tempValue > 11) {
            date.setFullYear(date.getFullYear() + 1)
        }
        date.setDate(timeline)
        return date.getDate() + `-${date.toLocaleString('en-US', { month: 'short' })}-${date.getFullYear()}`
    }
    // const [ selectedDate, setSelectedDate ] = useState(new Date())
    const freqLetter = (freq) => {
        switch (freq) {
            case 1:

                return 'M'
            case 2:

                return 'Q'
            case 3:

                return 'H'
            case 4:

                return 'A'

            default:
                break
        }
    }
    return (
        <div>
            <Dialog
                open={isOpen}
                onClose={handleClose}
                maxWidth="md"
                fullWidth
                PaperProps={{ sx: { overflowX: 'hidden', zIndex: 1300 } }}
            >
                <DialogContent sx={{ padding: 0 }}>
                    <div className='h-12 bg-primary flex items-center p-[0.8rem]'>
                        <div style={{ color: '#fff' }} className='flex-grow text-center text-white font-semibold'>{'Timeline'}</div>
                        <Tooltip title="Close" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <div className='cursor-pointer'><img src='/Common/Icon/CloseDialogX.svg' onClick={handleClose} /></div>
                        </Tooltip>
                    </div>
                    <div className='flex justify-end items-center p-4 !pb-0'>

                        <div className='flex items-center justify-center gap-2'>

                            <Tooltip
                                title={
                                    <div style={{ fontSize: '14px', color: 'black', padding: '8px' }}>
                                        <h2 className='border-b pb-2 text-lg text-primary'>Info</h2>
                                        <p className='pt-2 text-sm font-normal'>Compliance dates falling on non-working days will be adjusted to the nearest prior working day.</p>
                                    </div>
                                }
                                placement="bottom-end"
                                arrow
                                componentsProps={{
                                    tooltip: {
                                        sx: {
                                            bgcolor: '#fff',
                                            border: '1px solid hsl(var(--primary-foreground))',
                                            color: 'black',
                                            boxShadow: '0px 0px 8px 4px hsl(var(--primary-foreground))',
                                            fontSize: '14px',
                                            maxWidth: '400px',
                                            padding: '8px',
                                            borderRadius: '4px'
                                        }
                                    },
                                    arrow: {
                                        sx: {
                                            color: 'hsl(var(--primary))'
                                        }
                                    }
                                }}
                            >
                                <div>
                                    <IoMdInformationCircleOutline className="lg:w-8 lg:h-8 xl:w-6 xl:h-6 text-primary cursor-pointer" />
                                </div>
                            </Tooltip>
                            <div className='text-h4 text-center text-muted '>{new Date().getFullYear() + '-' + endYear}</div>

                        </div>

                    </div>
                    {/* <div className='w-full flex flex-col justify-center items-center py-5' >
                        <div className='flex flex-wrap border w-[90%] justify-center p-5 gap-2'>
                            { timeLineData.map((item, i) => {
                                return (
                                    <div key={i} className={cn(frequency === 3 || frequency === 2 ? 'w-[240px] h-[70px] justify-center' : 'w-[120px] justify-between', 'flex flex-row items-center')}>
                                        {frequency !== 1 && <div className={cn(frequency === 3 || frequency === 2 ? 'pr-4' : '')}>
                                            <div className='text-lg text-border font-bold'>{frequency === 4 ? getYear(item.dueDate) : frequency === 3 ? `${i + 1} Half` : `Q${i + 1}`}</div>
                                        </div>}
                                        <div>
                                            <div className='text-sm font-[#3C4048]'>{item.expMonth}</div>
                                            <div className='text-md text-primary font-bold'>{item.dueDate}</div>
                                        </div>
                                    </div>
                                )
                            })
                            }
                        </div>
                    </div> */}
                    <DialogContent>
                        <div style={{ border: '1px solid hsl(var(--popover))', borderRadius: '5px', overflow: 'hidden' }}>
                            <TableContainer component={Paper} style={{ maxHeight: '360px', overflow: 'auto' }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow >
                                            <TableCell align='center' style={{ color: 'hsl(var(--primary))', fontSize: '1.1rem' }} >#</TableCell>
                                            <TableCell align='center' style={{ color: 'hsl(var(--primary))', fontSize: '1.1rem' }} >{t('Due For')}</TableCell>
                                            <TableCell align='center' style={{ color: 'hsl(var(--primary))', fontSize: '1.1rem' }} >{t('Hard Target')}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {customMonthData?.map((item, index) => (
                                            <TableRow key={index}>
                                                <TableCell > <div style={{ fontSize: '1.1rem', backgroundColor: 'hsl(var(--primary-foreground))', color: 'hsl(var(--primary))', borderRadius: '50%', width: '30px', height: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 'auto' }}> {freqLetter(frequency)}{index + 1} </div> </TableCell>
                                                <TableCell align='center' style={{ fontSize: '1.1rem', whiteSpace: 'nowrap' }}>{item.dueFor}</TableCell>
                                                <TableCell align='center' style={{ display: 'flex', justifyContent: 'center', fontSize: '1.1rem', whiteSpace: 'nowrap' }}>
                                                    {type === 'Edit'
                                                        ? <div className='w-[70%]'>
                                                            {/* <MonthPicker value={selectedDate} onChange={setSelectedDate} cycle={cycle} timeline={timeline} /> */}
                                                            <SelectInput
                                                                placeholder="Select"
                                                                name={'period'}
                                                                // control={control}
                                                                required
                                                                // readOnly={}
                                                                options={generateMonthArray(cycle, timeline)}
                                                                value={item.dueByMonth}
                                                                className='relative'
                                                                defaultValue={item.dueByMonth}
                                                                onValueChange={value => onChange(value, index)}
                                                            // onValueChange={value => handleSelect(value, data.find(el => el.subtitleName === 'Start Month')?.configurationTitleId)}
                                                            />
                                                        </div>
                                                        : <div className='p-3 text-muted'>
                                                            {convertDate(item.dueByMonth, item.dueForMonth, timeline)}
                                                        </div>}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                    </DialogContent>
                    <div style={{ borderTop: '1px solid hsl(var(--primary-foreground))' }} className='flex gap-2 items-center p-4'>
                        <div className='text-primary text-semibold text-lg flex items-center gap-1'><span><img src='/Common/Icon/warningIcon.svg' />  </span> {' Soft Target :'}</div>
                        <div className='text-md flex items-center gap-3'>{interCutOff} Days before the hard target </div>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}
